import isBirthNumber from 'app/forms/validations/isBirthNumber';
import isBusinessIn from 'app/forms/validations/isBusinessIn';
import isFirstName from 'app/forms/validations/isFirstName';
import isMunicipality from 'app/forms/validations/isMunicipality';
import isSurname from 'app/forms/validations/isSurname';
import isYearOrder from 'app/forms/validations/isYearOrder';
import isZipCode from 'app/forms/validations/isZipCode';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const SEMAPHORE_FORM_NAME = 'semaphore-filter';

const { firstName, surname, personIn, businessIn, municipality, zipCode, productDomain, birthYearFrom, birthYearTo } =
	COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	surname,
	firstName,
	personIn,
	businessIn,
	productDomain,
	notInsuredProductDomain: 'notInsuredProductDomain',
	birthYearFrom,
	birthYearTo,
	feedback: 'feedback',
	municipality,
	zipCode,
	semaphore: 'semaphore',
	impendingState: 'impendingState',
};

export default () => ({
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [isSurname()],
	},
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [isFirstName()],
	},
	[FIELDS.personIn]: {
		deepPath: [FIELDS.personIn],
		validations: [isBirthNumber()],
	},
	[FIELDS.businessIn]: {
		deepPath: [FIELDS.businessIn],
		validations: [isBusinessIn()],
	},
	[FIELDS.productDomain]: {
		deepPath: [FIELDS.productDomain],
		validations: [],
	},
	[FIELDS.notInsuredProductDomain]: {
		deepPath: [FIELDS.notInsuredProductDomain],
		validations: [],
	},
	[FIELDS.birthYearFrom]: {
		deepPath: [FIELDS.birthYearFrom],
		validations: [
			isYearOrder({
				fromFieldName: FIELDS.birthYearFrom,
				toFieldName: FIELDS.birthYearTo,
			}),
		],
	},
	[FIELDS.birthYearTo]: {
		deepPath: [FIELDS.birthYearTo],
		validations: [
			isYearOrder({
				fromFieldName: FIELDS.birthYearFrom,
				toFieldName: FIELDS.birthYearTo,
			}),
		],
	},
	[FIELDS.feedback]: {
		deepPath: [FIELDS.feedback],
		validations: [],
	},
	[FIELDS.municipality]: {
		deepPath: [FIELDS.municipality],
		validations: [isMunicipality()],
	},
	[FIELDS.zipCode]: {
		deepPath: [FIELDS.zipCode],
		validations: [isZipCode()],
	},
	[FIELDS.semaphore]: {
		deepPath: [FIELDS.semaphore],
		validations: [],
	},
	[FIELDS.impendingState]: {
		deepPath: [FIELDS.impendingState],
		validations: [],
	},
});
